// import React, { useState } from 'react';
// import { Form, Input, InputNumber, DatePicker, Button, Table, message, Spin } from 'antd';
// import axios from 'axios';
// import moment from 'moment';
// import { app } from '../config';

// const FacialScanViewAll = () => {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [showTable, setShowTable] = useState(false);
// const [rewardCount, setRewardCount] = useState(0);
//   const handleSubmit = async (values) => {
//     try {
//       setLoading(true);

//       const payload = {
//         email: values.email,
//         scanCounts: values.scanCounts,
//         date: values.date ? values.date.format('YYYY-MM-DD') : null,
//         // date: values.date ? moment(values.date).format('YYYY-MM-DD') : null,
//       };
//         console.log("payload",payload)
// // return
//       // Replace with your API endpoint
//       const response = await axios.get(`${app.URL}/api/v1/static/addfacialreward?isWeb=true&email=${payload.email}&facialScans=${payload.scanCounts}&expiryDays=${payload.date}`);
//     //   const response = await axios.get(`http://localhost:3200/api/v1/static/addfacialreward?isWeb=true&email=${payload.email}&facialScans=${payload.scanCounts}&expiryDays=${payload.date}`);

//       /*
//         Expected Response Examples:

//         WITH DATA:
//         {
//           success: true,
//           data: [...]
//         }

//         WITHOUT DATA:
//         {
//           success: true,
//           data: []
//         }
//       */
// if (response?.data?.data && response?.data?.data?.length > 0) {
//   setTableData(response.data.data);
//   setRewardCount(response?.data?.rewardCount || 0);
//   setShowTable(true);

//   message.success('Data fetched successfully');
// } else {
//   setTableData([]);
//   setShowTable(false);

//   message.success(response?.data?.message || 'Submitted successfully');
// }
//     //   if (response?.data?.data && response?.data?.data?.length > 0) {
//     //     setTableData(response.data.data);
//     //     setShowTable(true);

//     //     message.success('Data fetched successfully');
//     //   }

//       form.resetFields();
//     } catch (error) {
//       console.log(error);
//   setTableData([]);
//   setShowTable(false);
//         setRewardCount(0);
//       message.error(error?.response?.data?.result?.msg || 'Something went wrong');
//     } finally {
//       setLoading(false);
//     }
//   };

// //   const columns = [
// //     {
// //       title: 'Email',
// //       dataIndex: 'email',
// //       key: 'email',
// //     },
// //     {
// //       title: 'Scan Counts',
// //       dataIndex: 'scanCounts',
// //       key: 'scanCounts',
// //     },
// //     {
// //       title: 'Date',
// //       dataIndex: 'date',
// //       key: 'date',
// //       render: (text) => (text ? moment(text).format('YYYY-MM-DD') : '-'),
// //     },
// //   ]
      
//       const columns = [
//         // {
//         //   title: 'Reward ID',
//         //   dataIndex: 'rewardId',
//         //   key: 'rewardId',
//         // },
//         // {
//         //   title: 'Patient ID',
//         //   dataIndex: 'patientId',
//         //   key: 'patientId',
//         // },
//         // {
//         //   title: 'Reward Type ID',
//         //   dataIndex: 'rewardTypeId',
//         //   key: 'rewardTypeId',
//         // },
//         {
//           title: 'Scan Count',
//           dataIndex: 'scanCount',
//           key: 'scanCount',
//         },
//         {
//           title: 'Expiry Date',
//           dataIndex: 'expiredAt',
//           key: 'expiredAt',
//           render: (text) => (text ? moment(text).format('YYYY-MM-DD') : '-'),
//         },
//         // {
//         //   title: 'Created At',
//         //   dataIndex: 'createdAt',
//         //   key: 'createdAt',
//         //   render: (text) => (text ? moment(text).format('YYYY-MM-DD HH:mm') : '-'),
//         // },
//       ];;

//   return (
//     <div className='dashboard-card container-fluid'>
//       <div className='row p-0 mb-4'>
//         <div
//           className='for-before col-12 col-lg-6 col-md-8 head fs-3 fw-bold p-3'
//           style={{
//             // backgroundColor: '#a7c1d9',
//             borderBottomRightRadius: '10px',
//             color: '#FFFFFF',
//           }}
//         >
//           Facial Scans
//         </div>
//       </div>

//       <div className='row'>
//         <div className='col-12'>
//           <Form form={form} layout='vertical' onFinish={handleSubmit}>
//             <div className='row'>
//               <div className='col-12 col-md-4'>
//                 <Form.Item
//                   label='Email'
//                   name='email'
//                   rules={[
//                     {
//                       required: true,
//                       message: 'Please enter email',
//                     },
//                     {
//                       type: 'email',
//                       message: 'Please enter valid email',
//                     },
//                   ]}
//                 >
//                   <Input placeholder='Enter email' size='large' />
//                 </Form.Item>
//               </div>

//               <div className='col-12 col-md-4'>
//                 <Form.Item
//                   label='Scan Counts'
//                   name='scanCounts'
//                   rules={[
//                     {
//                       required: true,
//                       message: 'Please enter scan counts',
//                     },
//                   ]}
//                 >
//                   <InputNumber placeholder='Enter scan counts' size='large' style={{ width: '100%' }} min={1} />
//                 </Form.Item>
//               </div>

//               <div className='col-12 col-md-4'>
//                 <Form.Item
//                   label='Expiry Date'
//                   name='date'
//                   rules={[
//                     {
//                       required: true,
//                       message: 'Please select date',
//                     },
//                   ]}
//                 >
//                   <DatePicker style={{ width: '100%' }} size='large' />
//                 </Form.Item>
//               </div>
//             </div>

//             <Form.Item>
//               <Button type='primary' htmlType='submit' loading={loading} size='large'>
//                 Submit
//               </Button>
//             </Form.Item>
//           </Form>
//         </div>
//       </div>

//       {loading ? (
//         <div className='text-center mt-4'>
//           <Spin size='large' />
//         </div>
//       ) : (
//         <>
//           {/* {showTable && (
//             <div className='row mt-4'>
//               <div className='col-12'>
//                 <Table columns={columns} dataSource={tableData} rowKey={(record, index) => index} bordered pagination={{ pageSize: 10 }} />
//               </div>
//             </div>
//           )} */}

//           {showTable && (
//             <div className='row mt-4'>
//               <div className='col-12'>
//                 <div className='mb-3 fs-5 fw-bold'>Total Reward Count: {rewardCount}</div>

//                 <Table columns={columns} dataSource={tableData} rowKey='rewardId' bordered pagination={{ pageSize: 10 }} />
//               </div>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default FacialScanViewAll;


import React, { useState } from 'react';
import { Form, Input, InputNumber, DatePicker, Button, Table, message, Spin, Modal } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { app } from '../config';

const FacialScanViewAll = () => {
  const [searchForm] = Form.useForm();
  const [addForm] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [rewardCount, setRewardCount] = useState(0);

  const [showTable, setShowTable] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  // =========================
  // SEARCH API
  // =========================
  const handleSearch = async (values) => {
    try {
      setLoading(true);
      // const response = await axios.get(`http://localhost:3200/api/v1/app/anura/check?email=${values.email}`);

      const response = await axios.get(`${app.URL}/api/v1/app/anura/check?email=${values.email}`);

      if (response?.data?.success) {
        setTableData(response?.data?.data?.data || []);
        setRewardCount(response?.data?.data?.rewardCount || 0);
        setShowTable(true);

        message.success('Data fetched successfully');
      } else {
        setTableData([]);
        setRewardCount(0);
        setShowTable(false);

        message.error(response?.data?.msg || 'No data found');
      }
    } catch (error) {
      console.log(error);

      setTableData([]);
      setRewardCount(0);
      setShowTable(false);

      message.error(error?.response?.data?.msg || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // ADD FACIAL SCAN API
  // =========================
  const handleAddFacialScan = async (values) => {
    try {
      setAddLoading(true);

      const payload = {
        email: values.email,
        scanCounts: values.scanCounts,
        expiryDate: values.date.format('YYYY-MM-DD'),
      };

      await axios.get(`${app.URL}/api/v1/static/addfacialreward?isWeb=true&email=${payload.email}&facialScans=${payload.scanCounts}&expiryDays=${payload.expiryDate}`);

      message.success('Facial reward added successfully');

      setOpenModal(false);
      addForm.resetFields();

      // Refresh listing automatically
      handleSearch({
        email: payload.email,
      });
    } catch (error) {
      console.log(error);

      message.error(error?.response?.data?.msg || 'Something went wrong');
    } finally {
      setAddLoading(false);
    }
  };

  // =========================
  // TABLE COLUMNS
  // =========================
  const columns = [
    {
      title: 'Scan Count',
      dataIndex: 'scanCount',
      key: 'scanCount',
    },
    // {
    //   title: 'Facial Scans',
    //   dataIndex: 'facialScans',
    //   key: 'facialScans',
    // },
    {
      title: 'Expiry Date',
      dataIndex: 'expiredAt',
      key: 'expiredAt',
      render: (text) => (text ? moment(text).format('YYYY-MM-DD') : '-'),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => (text ? moment(text).format('YYYY-MM-DD ') : '-'),
    },
  ];

  return (
    <div className='dashboard-card container-fluid  '>
      {/* HEADER */}
      <div className='row p-0 mb-4'>
        <div
          className='for-before col-12 col-lg-6 col-md-8 head fs-3 fw-bold p-3'
          style={{
            borderBottomRightRadius: '10px',
            color: '#FFFFFF',
          }}
        >
          Facial Scans
        </div>
      </div>

      {/* SEARCH + ADD BUTTON */}
      <div className='row mb-4 align-items-end'>
        <div className='col-md-8'>
          <Form form={searchForm} layout='vertical' onFinish={handleSearch}>
            <div className='row'>
              <div className='col-md-8'>
                <Form.Item
                  label='Email'
                  name='email'
                  rules={[
                    {
                      required: true,
                      message: 'Please enter email',
                    },
                    {
                      type: 'email',
                      message: 'Please enter valid email',
                    },
                  ]}
                >
                  <Input placeholder='Enter email' size='large' />
                </Form.Item>
              </div>

              <div className='col-md-4 d-flex align-items-end'>
                <Form.Item>
                  <Button type='primary' htmlType='submit' loading={loading} size='large'>
                    Search
                  </Button>
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>

        <div className='col-md-4 text-end   '
          style={{
          marginBottom:'20px'
        }}
        >
          <Button
            type='primary'
            size='large'
            onClick={() => {
              const email = searchForm.getFieldValue('email');

              addForm.setFieldsValue({
                email,
              });

              setOpenModal(true);
            }}
          >
            Add Facial Scan
          </Button>
        </div>
      </div>

      {/* LOADER */}
      {loading ? (
        <div className='text-center mt-5'>
          <Spin size='large' />
        </div>
      ) : (
        <>
          {/* TABLE */}
          {showTable && (
            <div className='row mt-4'>
              <div className='col-12'>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <div className='fs-5 fw-bold'>Total Reward Count : {rewardCount}</div>

                  {/* <div className='fs-6 fw-semibold'>Remaining : {rewardCount}</div> */}
                </div>

                <Table
                  columns={columns}
                  dataSource={tableData}
                  rowKey='rewardId'
                  bordered
                  pagination={{
                    pageSize: 10,
                    total: tableData.length,
                    showSizeChanger: true,
                  }}
                />
              </div>
            </div>
          )}
        </>
      )}

      {/* ADD MODAL */}
      <Modal
        title='Add Facial Scan'
        open={openModal}
        onCancel={() => {
          setOpenModal(false);
          addForm.resetFields();
        }}
        footer={null}
        destroyOnClose
      >
        <Form form={addForm} layout='vertical' onFinish={handleAddFacialScan}>
          {/* EMAIL */}
          <Form.Item
            label='Email'
            name='email'
            rules={[
              {
                required: true,
                message: 'Please enter email',
              },
              {
                type: 'email',
                message: 'Please enter valid email',
              },
            ]}
          >
            <Input placeholder='Enter email' size='large' />
          </Form.Item>

          {/* SCAN COUNT */}
          <Form.Item
            label='Scan Count'
            name='scanCounts'
            rules={[
              {
                required: true,
                message: 'Please enter scan count',
              },
            ]}
          >
            <InputNumber placeholder='Enter scan count' min={1} size='large' style={{ width: '100%' }} />
          </Form.Item>

          {/* DATE */}
          <Form.Item
            label='Expiry Date'
            name='date'
            rules={[
              {
                required: true,
                message: 'Please select expiry date',
              },
            ]}
          >
            <DatePicker
              style={{ width: '100%' }}
              size='large'
              disabledDate={(current) => {
                return current && current < moment().startOf('day');
              }}
            />
          </Form.Item>

          {/* SUBMIT */}
          <Form.Item className='mb-0'>
            <div className='d-flex justify-content-end gap-2'>
              <Button
                onClick={() => {
                  setOpenModal(false);
                  addForm.resetFields();
                }}
              >
                Cancel
              </Button>

              <Button type='primary' htmlType='submit' loading={addLoading}>
                Submit
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default FacialScanViewAll;